<template>
  <div>
    <dara-small
      v-if="(articles && parseInt(tag.articles) > articles.length) || (questions && parseInt(tag.questions) > questions.length)"
      class="color--danger">
      * {{ $t('some-articles-and-questions-are-not-available-due-to-your-permission') }}
    </dara-small>
    <el-tabs v-model="tabActive" class="mt-2" @tab-click="fetch">
      <el-tab-pane :label="`${$t('tag-articles')} ( ${parseInt(tag.articles)} )`" name="articles">
        <div v-if="articles && articles.length">
          <div
            v-for="article in articles"
            :key="article.id"
            class="mb--xl">
            <dara-article-card :article="article" />
          </div>
        </div>
        <div v-if="articles && articles.length" class="d-flex justify-content-center">
          <dara-pagination
            :page.sync="pagination.page"
            :total="pagination.total"
            :page-size="pagination.limit"
            @current-change="fetch" />
        </div>
        <dara-p v-else class="opacity--50 my--md">( {{ $t('no-articles') }} )</dara-p>
      </el-tab-pane>
      <el-tab-pane
        :label="`${$t('tag-questions')} ( ${parseInt(tag.questions)} )`"
        name="questions">
        <table v-if="questions && questions.length" class="table mb-5">
          <tbody>
            <tr v-for="question in questions" :key="question.id">
              <td class="px-2">
                <h5>
                  <dara-question-link :id="question.id">
                    {{ question.title }}
                  </dara-question-link>
                  <small v-if="question.answered">
                    <span
                      class="badge rounded-pill bg-light text-dark fw-light me-1">
                      {{ $t('answered') }}
                    </span>
                  </small>
                </h5>
                <dara-p class="text-muted">
                  {{ question.content }}
                </dara-p>
              </td>
              <td class="align-middle text-end">
                <el-dropdown trigger="click">
                  <dara-icon
                    icon="three-dots-vertical"
                    class="cursor--pointer mx--md" />
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                      <a @click="setDeleteQuestion(question)">
                        <dara-icon size="sm" icon="trash" />
                        {{ $t('delete') }}
                      </a>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <dara-modal-delete
                  v-if="showModal(question)"
                  :content="$t('are-you-sure-you-want-to-delete-this-question')"
                  @close="setDeleteQuestion(null)"
                  @confirm="$emit('deleteQuestion', question)">
                </dara-modal-delete>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-if="questions && questions.length" class="d-flex justify-content-center">
          <dara-pagination
            :page.sync="pagination.page"
            :total="pagination.total"
            :page-size="pagination.limit"
            @current-change="fetch" />
        </div>
        <dara-p v-else class="opacity--50 my--md">( {{ $t('no-questions') }} )</dara-p>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getters } from '@/modules/user/user.store';
import { fetchTagArticles } from '@/modules/article/article.service';
import { fetchTagQuestions } from '@/modules/question/question.service';
import { toastError } from '@/services/toastService';
import { translate } from '@/services/translate.service';

import DaraArticleCard from '@/modules/article/components/ArticleCard.vue';
import DaraQuestionLink from '@/modules/question/components/QuestionLink.vue';

export default {
  name: 'DaraTagArticlesAndQuestions',
  components: {
    DaraArticleCard,
    DaraQuestionLink,
  },
  props: {
    tag: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currentUser: null,
      articles: null,
      questions: null,
      questionDelete: null,
      tabActive: 'articles',
      pagination: {
        page: 1,
        limit: 5,
      },
    };
  },
  mounted() {
    this.currentUser = getters.getUser();
    if (this.tag.articles < 1 && this.tag.questions > 0) {
      this.tabActive = 'questions';
    }
    this.fetch();
  },
  methods: {
    fetch() {
      this.fetchArticles();
      this.fetchQuestions();
    },
    fetchArticles() {
      fetchTagArticles(this.tag, this.pagination)
        .then(data => {
          this.articles = data.data;
          Object.assign(this.pagination, data.pagination);
        })
        .catch(() => toastError(`${translate('error-getting-articles-from-tag')}`));
    },
    fetchQuestions() {
      fetchTagQuestions(this.tag, this.pagination)
        .then(data => {
          this.questions = data.data;
          Object.assign(this.pagination, data.pagination);
        })
        .catch(() => toastError(`${translate('error-getting-questions-from-tag')}`));
    },
    setDeleteQuestion(question) {
      this.questionDelete = question;
    },
    showModal(question) {
      return this.questionDelete && this.questionDelete.id === question.id;
    },
  },
};
</script>
